function bit_sum(num, bits) {
    let s = 0;
    for (let i = 0; i < bits; i++) {
        s += num & (1 << i);
    }
    return s;
}
function digitSum(n) {
    let q = 0;
    while (n !== 0) {
        q += n % 10;
        n = Math.floor(n / 10);
    }
    return q;
}
function numberToPaddedHexadecimal(num, l) {
    return num.toString(16)
        .toUpperCase()
        .padStart(l, '0');
}
function asciicode(s) {
    return s.split('')
        .map((c) => numberToPaddedHexadecimal(c.charCodeAt(0), 2))
        .join('');
}
function swapBytes(s) {
    let b = "";
    for (let i = 0; i < s.length; i += 2) {
        b += s[i + 1];
        b += s[i];
    }
    return b;
}

const HHD_VERSION_13 = 13;
const HHD_VERSION_14 = 14;
const LC_LENGTH_HHD14 = 3;
const LC_LENGTH_HHD13 = 2;
const LDE_LENGTH_DEFAULT = 2;
const LDE_LENGTH_SPARDA = 3;
const BIT_ENCODING = 6; // Position of encoding bit
const BIT_CONTROLBYTE = 7; // Position of bit that tells if there are a control byte
const ENCODING_ASC = 1;
const ENCODING_BCD = 2;
class FlickerCode {
    constructor(code, version, ldeLength = LDE_LENGTH_DEFAULT) {
        this.version = version;
        this.lc = null;
        this.startcode = new Startcode();
        this.de1 = new DE(ldeLength);
        this.de2 = new DE(ldeLength);
        this.de3 = new DE(ldeLength);
        this.rest = null;
        this.parse(code);
    }
    static parse(code) {
        try {
            new FlickerCode(code, HHD_VERSION_14);
        }
        catch (e) {
            try {
                return new FlickerCode(code, HHD_VERSION_14, LDE_LENGTH_SPARDA);
            }
            catch (e) {
                try {
                    return new FlickerCode(code, HHD_VERSION_13);
                }
                catch (e) {
                    console.error(e);
                }
            }
        }
    }
    // Render
    getCode() {
        const s = this.createPayload();
        const luhn = this.createLuhnChecksum();
        const xor = this.createXorChecksum(s);
        return s + luhn + xor;
    }
    createPayload() {
        let s = this.startcode.renderLength();
        for (let b of this.startcode.controlBytes) {
            s += numberToPaddedHexadecimal(+b, 2);
        }
        s += this.startcode.renderData();
        for (let de of [this.de1, this.de2, this.de3]) {
            let renderlength = de.renderLength();
            let renderdata = de.renderData();
            s += renderlength;
            s += renderdata;
        }
        let l = Math.floor((s.length + 2) / 2);
        let lc = numberToPaddedHexadecimal(l, 2);
        return lc + s;
    }
    createLuhnChecksum() {
        let s = "";
        for (let b of this.startcode.controlBytes) {
            s += numberToPaddedHexadecimal(b, 2);
        }
        s += this.startcode.renderData();
        if (this.de1.data)
            s += this.de1.renderData();
        if (this.de2.data)
            s += this.de2.renderData();
        if (this.de3.data)
            s += this.de3.renderData();
        let luhnsum = 0;
        for (let i = 0; i < s.length; i += 2) {
            luhnsum += parseInt(s[i], 16) + digitSum(2 * parseInt(s[i + 1], 16));
        }
        let m = luhnsum % 10;
        if (m == 0)
            return "0";
        let r = 10 - m;
        let ss = luhnsum + r;
        let luhn = ss - luhnsum;
        return numberToPaddedHexadecimal(luhn, 1);
    }
    createXorChecksum(payload) {
        let xorSum = 0;
        for (let c of payload) {
            xorSum ^= parseInt(c, 16);
        }
        return numberToPaddedHexadecimal(xorSum, 1);
    }
    parse(code) {
        let length = this.version == HHD_VERSION_14 ? LC_LENGTH_HHD14 : LC_LENGTH_HHD13;
        this.lc = parseInt(code.slice(0, length));
        if (code.length < length + this.lc) {
            throw new Error(`lc too large: ${this.lc} + ${length} > ${code.length}`);
        }
        code = code.substring(length);
        code = this.startcode.parse(code);
        this.version = this.startcode.version;
        code = this.de1.parse(code, this.version);
        code = this.de2.parse(code, this.version);
        code = this.de3.parse(code, this.version);
        this.rest = code !== null && code !== void 0 ? code : null;
    }
}
class DE {
    constructor(ldeLength) {
        this.length = 0;
        this.lde = 0;
        this.encoding = null;
        this.data = null;
        this.ldeLength = ldeLength;
    }
    parse(data, version) {
        this.version = version;
        if (!data)
            return data;
        this.lde = parseInt(data.slice(0, this.ldeLength));
        data = data.substring(this.ldeLength);
        this.length = bit_sum(this.lde, 5);
        this.data = data.slice(0, this.length);
        return data.substring(this.length);
    }
    setEncoding() {
        if (this.data == null) {
            this.encoding = ENCODING_BCD;
        }
        else if (this.encoding != null) ;
        else if (/^[0-9]{1,}$/.test(this.data)) {
            this.encoding = ENCODING_BCD;
        }
        else {
            this.encoding = ENCODING_ASC;
        }
    }
    renderLength() {
        this.setEncoding();
        if (!this.data)
            return "";
        let l = Math.floor(this.renderData().length / 2);
        if (this.encoding == ENCODING_BCD)
            return numberToPaddedHexadecimal(l, 2);
        if (this.version == HHD_VERSION_14) {
            l = l + (1 << BIT_ENCODING);
            return numberToPaddedHexadecimal(l, 2);
        }
        return "1" + numberToPaddedHexadecimal(l, 1);
    }
    renderData() {
        this.setEncoding();
        if (!this.data)
            return "";
        if (this.encoding == ENCODING_ASC)
            return asciicode(this.data);
        if (this.data.length % 2 == 1)
            return this.data + "F";
        return this.data;
    }
}
class Startcode extends DE {
    constructor() {
        super(LDE_LENGTH_DEFAULT);
        this.controlBytes = [];
        this.controlBytes = [];
    }
    parse(data) {
        this.lde = parseInt(data.slice(0, 2), 16);
        data = data.substring(2);
        this.length = bit_sum(this.lde, 5);
        this.version = HHD_VERSION_13;
        if ((this.lde & (1 << BIT_CONTROLBYTE)) !== 0) {
            this.version = HHD_VERSION_14;
            for (let i = 0; i < 10; i++) {
                let cbyte = parseInt(data.slice(0, 2), 16);
                this.controlBytes.push(cbyte);
                data = data.substring(2);
                if ((cbyte & (1 << BIT_CONTROLBYTE)) == 0) {
                    break;
                }
            }
        }
        this.data = data.slice(0, this.length);
        return data.substring(this.length);
    }
    renderLength() {
        let s = super.renderLength();
        if (this.version == HHD_VERSION_13 || !this.controlBytes)
            return s;
        let l = parseInt(s, 16) + (1 << BIT_CONTROLBYTE);
        return numberToPaddedHexadecimal(l, 2);
    }
}

const template = document.createElement('template');
template.innerHTML = `
<style>
:host {
    display: block;
    height: 100px;
    width: 205px;
    overflow: hidden;
}

#flickerCanvas {
    width: 100%;
    height: 100%;
}
</style>


<canvas id="flickerCanvas"></canvas>
`;
class OptiTAN extends HTMLElement {
    constructor() {
        super();
        this.speed = 50;
        this.halfbyteid = 0;
        // attach to the Shadow DOM
        this.root = this.attachShadow({ mode: 'closed' });
        this.root.appendChild(template.content.cloneNode(true));
    }
    static get observedAttributes() {
        return ['tan-code', 'speed'];
    }
    connectedCallback() {
        this.prepareValues();
        this.initiateOptiTAN();
    }
    attributeChangedCallback() {
        this.prepareValues();
        this.initiateOptiTAN();
    }
    prepareValues() {
        this.bitarray = undefined;
        this.halfbyteid = 0;
        const speedAttribute = this.attributes['speed'];
        if (!speedAttribute || !speedAttribute.value) {
            this.speed = 50;
        }
        else {
            this.speed = speedAttribute.value;
        }
    }
    initiateOptiTAN() {
        const tanCodeAttribute = this.attributes['tan-code'];
        if (!tanCodeAttribute || !tanCodeAttribute.value) {
            console.warn('No `tan-code` attribute provided!');
            return;
        }
        this.flickerCode = FlickerCode.parse(tanCodeAttribute.value);
        if (!this.flickerCode) {
            console.warn('No flicker code could be created');
            return;
        }
        this.initiateFlicker();
    }
    initiateFlicker() {
        this.canvas = this.root.getElementById('flickerCanvas');
        this.context = this.canvas.getContext("2d");
        this.initiateCanvas();
        this.createBitArray();
        this.startFlicker();
    }
    initiateCanvas() {
        this.canvas.width = 205;
        this.canvas.height = 100;
        this.context.fillStyle = "rgb(0,0,0)";
        this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
    }
    createBitArray() {
        let code = this.flickerCode.getCode();
        code = swapBytes(code);
        // Prepend start sequence
        this.bitarray = [
            [1, 0, 0, 0, 0],
            [0, 0, 0, 0, 0],
            [1, 1, 1, 1, 1],
            [0, 1, 1, 1, 1],
            [1, 1, 1, 1, 1],
            [0, 1, 1, 1, 1],
            [1, 1, 1, 1, 1],
        ];
        for (let char of code) {
            let v = parseInt(char, 16);
            // Create bits from code and push it twice, so that the clock gets pulsed twice for each halfbyte
            this.bitarray.push([
                1, v & 1, (v & 2) >> 1, (v & 4) >> 2, (v & 8) >> 3
            ]);
            this.bitarray.push([
                0, v & 1, (v & 2) >> 1, (v & 4) >> 2, (v & 8) >> 3
            ]);
        }
    }
    step() {
        let margin = 7;
        let barwidth = this.canvas.width / 5;
        for (let i = 0; i < 5; i++) {
            if (this.bitarray[this.halfbyteid][i] == 1) {
                this.context.fillStyle = "rgb(255,255,255)";
            }
            else {
                this.context.fillStyle = "rgb(0,0,0)";
            }
            this.context.fillRect(i * barwidth + margin, margin, barwidth - 2 * margin, this.canvas.height - 2 * margin);
        }
        this.halfbyteid++;
        if (this.halfbyteid >= this.bitarray.length) {
            this.halfbyteid = 0;
        }
    }
    startFlicker() {
        if (this.flickerTimer) {
            window.clearInterval(this.flickerTimer);
        }
        this.flickerTimer = window.setInterval(// Properly use class context
        (function (self) {
            return function () {
                self.step();
            };
        })(this), this.speed);
    }
}
customElements.define('optitan-flicker', OptiTAN);
//# sourceMappingURL=optitan-flicker.js.map
